import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDashboardHeaderData } from '../../services/api/implementation/impl';
import Layout from './AppLayout';
import Header from '../../../shared/components/layout/Header';
import HeaderCard from '../../../shared/components/ui/HeaderCard';
import toast from 'react-hot-toast';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const Dashboard = () => {
  const [newData, setNewData] = useState([]);
  const userId = Cookies.get('userId');

  // Page view tracking
  useEffect(() => {
    mixpanel.track('Super Admin Dashboard Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  // Data fetching
  const { data, refetch: refetchDashboardDetails } = useQuery({
    queryKey: ['dashboard'],
    queryFn: () => getDashboardHeaderData(),
    onSuccess: (result) => {
      // Check if result is an error object
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        mixpanel.track('Super Admin Dashboard Data Fetch Failed', {
          user_id: userId,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        toast.error(
          result?.response?.data?.message || result?.message || 'Failed to fetch dashboard data'
        );
        return;
      }

      mixpanel.track('Super Admin Dashboard Data Fetch Success', {
        user_id: userId,
        total_builders: result?.values?.[result?.keys?.indexOf('totalBuilders')] || 0,
        active_builders: result?.values?.[result?.keys?.indexOf('activeBuilder')] || 0,
        timestamp: new Date().toISOString()
      });
      toast.success('Successfully fetched dashboard data');
    },
    onError: (err) => {
      mixpanel.track('Super Admin Dashboard Data Fetch Failed', {
        user_id: userId,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
      toast.error(err?.response?.data?.message || err?.message || 'Failed to fetch dashboard data');
    }
  });

  useEffect(() => {
    if (data) {
      const totalBuilders = data.values[data.keys.indexOf('totalBuilders')];
      const activeBuilders = data.values[data.keys.indexOf('activeBuilder')];
      const inactiveBuilders = totalBuilders - activeBuilders;

      const updatedData = [
        { key: 'Total Builders', value: totalBuilders, type: 'information' },
        { key: 'Active Builders', value: activeBuilders, type: 'completed' },
        { key: 'Inactive Builders', value: inactiveBuilders, type: 'ongoing' }
      ];

      setNewData(updatedData);

      // Track dashboard metrics update
      mixpanel.track('Super Admin Dashboard Metrics Updated', {
        user_id: userId,
        total_builders: totalBuilders,
        active_builders: activeBuilders,
        inactive_builders: inactiveBuilders,
        timestamp: new Date().toISOString()
      });
    }
  }, [data, userId]);

  // JSX
  return (
    <Layout>
      {/* Header */}
      <div className="fixed z-[20] top-0 left-[16.5vw] w-[83.5vw]">
        <Header data={{ name: 'Dashboard' }} />
      </div>

      <div className="flex flex-wrap justify-between items-center gap-4 px-8 mt-[6rem]">
        {newData?.map((item, index) => (
          <div className="w-[46%]" key={index}>
            <HeaderCard data={item} />
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default Dashboard;
